let TableLegend = (props) => {
    return (<div className="table-legend">
        <div className="legend-circle legend-done" data-hover="완료된 레슨"></div>
        <div className="legend-circle legend-abnormally-cancelled" data-hover="당일 취소된 레슨"></div>
        <div className="legend-circle legend-reservation" data-hover="일반 레슨"></div>
        <div className="legend-circle legend-reservation-grand" data-hover="그랜드 레슨"></div>
    </div>)
}
export default TableLegend;